import { render, staticRenderFns } from "./ElemRoot.vue?vue&type=template&id=5ce89e24"
import script from "./ElemRoot.vue?vue&type=script&lang=js"
export * from "./ElemRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports